import { render, staticRenderFns } from "./GroupBookingCommitDialog.vue?vue&type=template&id=6b3122a3&scoped=true&"
import script from "./GroupBookingCommitDialog.vue?vue&type=script&lang=js&"
export * from "./GroupBookingCommitDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3122a3",
  null
  
)

export default component.exports